if (!customElements.get('sove-set-buy-form')) {
  customElements.define(
    'sove-set-buy-form',
    class SoveSetBuyForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.errorMessage = this.querySelector('.sove-set-buy-modal__error');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const groups = Array.from(this.form.querySelectorAll('[data-variant-group]'));
        const items = [];
        let missingSize = false;

        groups.forEach((group) => {
          group.classList.remove('sove-set-buy-modal__pills--error');
          const checked = group.querySelector('input[type="radio"]:checked');
          if (!checked) {
            missingSize = true;
            group.classList.add('sove-set-buy-modal__pills--error');
          } else {
            items.push({ id: parseInt(checked.value, 10), quantity: 1 });
          }
        });

        if (missingSize) {
          this.showError('Please select a size for each item.');
          return;
        }

        this.showError(false);
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              return Promise.reject(new Error('add-to-cart-failed'));
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sove-set-buy-form',
              cartData: response,
            });

            if (!this.cart) {
              window.location = routes.cart_url;
              return Promise.reject(new Error('no-cart-drawer'));
            }

            // Fetch each section's fresh HTML individually via ?section_id=,
            // the same mechanism cart.js already uses elsewhere in this
            // theme — rather than relying on /cart/add.js's `sections` param,
            // which isn't reliably returned for a multi-item `items` payload.
            const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
            return Promise.all(
              sectionIds.map((id) =>
                fetch(`${routes.cart_url}?section_id=${id}`)
                  .then((response) => response.text())
                  .then((html) => [id, html])
              )
            ).then((entries) => ({ sections: Object.fromEntries(entries) }));
          })
          .then((parsedState) => {
            const modal = this.closest('modal-dialog');
            if (modal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => this.cart.renderContents(parsedState));
                },
                { once: true }
              );
              modal.hide();
            } else {
              this.cart.renderContents(parsedState);
            }
          })
          .catch((error) => {
            if (error.message !== 'add-to-cart-failed' && error.message !== 'no-cart-drawer') {
              console.error(error);
              this.showError('Something went wrong. Please try again.');
            }
          })
          .finally(() => {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      showError(message) {
        if (!this.errorMessage) return;
        if (!message) {
          this.errorMessage.setAttribute('hidden', '');
          this.errorMessage.textContent = '';
        } else {
          this.errorMessage.removeAttribute('hidden');
          this.errorMessage.textContent = message;
        }
      }
    }
  );
}
